import { render, staticRenderFns } from "./LoanTable.vue?vue&type=template&id=5232aa4e&"
import script from "./LoanTable.vue?vue&type=script&lang=js&"
export * from "./LoanTable.vue?vue&type=script&lang=js&"
import style0 from "./LoanTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports